export default {"src":"https://dap-ew1o85bkc-dap-rewrite.vercel.app/_next/static/media/MyprofileChevronRight.b33c9c98.svg","height":49,"width":48};